import { render, staticRenderFns } from "./PerkPointLabel.vue?vue&type=template&id=991c608c&scoped=true"
import script from "./PerkPointLabel.vue?vue&type=script&lang=js"
export * from "./PerkPointLabel.vue?vue&type=script&lang=js"
import style0 from "./PerkPointLabel.vue?vue&type=style&index=0&id=991c608c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991c608c",
  null
  
)

export default component.exports